<h2 mat-dialog-title class="pb-0 mb-0">Usługi</h2>
<p class="text-muted small mb-0 px-4">Zarządzaj usługami dla uczestników rezerwacji</p>
<mat-dialog-content class="overflow-hidden">
	<mat-divider class="mb-3"></mat-divider>

	<div class="d-flex gap-2 align-items-center">
		<div class="flex-grow-1">
			<mat-form-field
				[appearance]="formFieldAppearance"
				[subscriptSizing]="formFieldSubscriptSizing"
				class="w-100"
			>
				<mat-label>Wybierz usługę</mat-label>
				<input
					matInput
					type="text"
					[formControl]="globalServiceControl"
					[matAutocomplete]="globalServiceAutocomplete"
				/>
				<mat-autocomplete
					#globalServiceAutocomplete="matAutocomplete"
					(optionSelected)="onGlobalServiceSelected($event)"
				>
					@for (service of globalAutocompleteOptions(); track service.id) {
						<mat-option [value]="service.name">{{ service.name }}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>
		</div>
		<div class="flex-shrink-0">
			<button
				mat-raised-button
				color="primary"
				class="text-nowrap"
				[disabled]="!selectedGlobalService()"
				(click)="addServiceToAllSlots()"
			>
				Dodaj do wszystkich
			</button>
		</div>
	</div>

	<mat-divider class="my-3"></mat-divider>

	<div class="participants-list overflow-auto">
		@for (slot of slots(); track slot.id; let index = $index) {
			<mat-card [appearance]="sectionsAppearance" class="participant-card">
				<mat-card-content class="py-3">
					<app-reservation-services-dialog-participant
						[slotIndex]="index"
						[slot]="slot"
						[initialServicesSum]="initialSlotServicesSumAt(index)"
						[initialPriceAdjustment]="initialSlotPriceAdjustmentAt(index)"
						[allServices]="allServices()"
						[formFieldAppearance]="formFieldAppearance"
						[formFieldSubscriptSizing]="formFieldSubscriptSizing"
						[serviceControl]="participantControlAt(index)"
						(removeService)="removeServiceFromSlot(index, $event)"
						(addService)="addServiceToSlot(index, $event)"
						(priceAdjustmentChange)="updateSlotPriceAdjustment(index, $event)"
					/>
				</mat-card-content>
			</mat-card>
		}
	</div>

	<mat-divider class="my-3"></mat-divider>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-between align-items-end w-100 px-4 py-0">
	<div class="d-flex align-items-stretch">
		<div class="d-flex flex-column pe-4">
			<span class="text-muted small mb-0">Suma wybranych usług</span>
			<div class="d-flex align-items-center gap-2">
				<span class="fw-semibold fs-4">{{ selectedServicesTotal() | price }} PLN</span>
				<span
					class="badge rounded-pill"
					[class.bg-success-subtle]="priceDifference() < 0"
					[class.text-success]="priceDifference() < 0"
					[class.bg-danger-subtle]="priceDifference() > 0"
					[class.text-danger]="priceDifference() > 0"
				>
					{{ priceDifference() > 0 ? '+' : '' }}{{ priceDifference() | price }} PLN
				</span>
			</div>
		</div>
		<mat-divider vertical class="price-summary-divider"></mat-divider>
		<div class="d-flex flex-column ps-4">
			<span class="text-muted small mb-0">Łączna cena za ofertę</span>
			<span class="fw-semibold fs-4">{{ offerTotalPrice() | price }} PLN</span>
		</div>
	</div>
	<div class="d-flex gap-2">
		<button mat-raised-button color="primary" [disabled]="isSaving()" (click)="saveServices()">Zapisz</button>
		<button mat-raised-button color="warn" [disabled]="isSaving()" (click)="closeDialog()">Anuluj</button>
	</div>
</mat-dialog-actions>
